import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const HznSourcingGroups = () => {
  return (
    <MicroFrontEnd
      name="HznSourcingGroups"
      src={apiConfig.microFrontEnds.HznSourcingGroups}
    />
  )
}

export default HznSourcingGroups
